// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_layout_layout_module_ts":"86cb254ddaf0e13e5eec","src_app_reports_reports_module_ts":"116fd7ab16cda3f28a89"}[chunkId] + ".js";
};